import store from '../stores/store'

let firstProducts = {};
const individualServiceCategories = ["Hotel Service", "Insurance", "Visa"];

export const getFirstProduct = () => {
    return firstProducts
};

export const updateFirstProduct = (data) => {
    const roomCategory = data.RoomCategory.Value || "";
    const room = data.Room.Value || "";
    const accomodationType = data.AccomodationType.Value || "";
    const pansion = data.Pansion.Value || "";
    const roomtype = `${accomodationType} / ${roomCategory} / ${room} / ${pansion}`;

    firstProducts.roomtypeOld = firstProducts.roomtype || roomtype;
    firstProducts.roomtype = roomtype;
};

export const login = (login) => {
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
        "event": "Authorize",
        "eventdata": {
            "category": "SendForm",
            "action": "Authorize"
        },
        "USER_ID": login
    });
};

export const registration = () => {
    let dataLayer = window.dataLayer || [];
    dataLayer.push ({
        "event": "Register",
        "eventdata": {
            "category": "SendForm",
            "action": "Register"
        }
    });
};

export const sendResults = (arr, gtm, currency) => {
    if (!arr.length) return;

    // const results = arr.slice(gtm.impressionsCount);
    const currencies = store.getters['getCurrency'];
    const currencyCode = currencies.find(x => x.Code === currency).IsoCode;
    const impressions = [];
    arr.forEach((x, i) => {
        let brand = x.Services.find(x2 => x2.SvKey === 1)?.ArrivalCountry?.Value || "";
        if (!brand) {
            brand = x.Services.find(x2 => x2.SvKey === 3)?.Country?.Value || "";
        }
        let index = gtm[x.IsRemoteHotels ? 'impressionsCountRemote' : 'impressionsCountLocal'] + i;
        impressions.push({
            "id": x.Key,
            "name": x.Name,
            "price": convertCurrency(currencyCode, x.Cost),
            "brand": brand,
            "category": "Tour",
            "position": index,
            "list": "Результаты поиска"
        });
    });

    let dataLayer = window.dataLayer || [];
    dataLayer.push({ "ecommerce": null });
    dataLayer.push({
        "event": "results",
        "ecommerce": {
            "currencyCode": store.getters['getNationalRate'].IsoCode, //window.settings.GTM_CurrencyIsoCode,
            "impressions": impressions,
        }
    });
};

export const tourVariantsShow = (data, key, currency) => {
    const hotel = data.Services.find(x2 => x2.SvKey === 3);
    const brand = hotel?.Country?.Value || "";
    const roomCategory = hotel.HotelDetails[0].RoomCategory.Value;
    const room = hotel.HotelDetails[0].Room.Value;
    const accomodationType = hotel.HotelDetails[0].AccomodationType.Value;
    const pansion = hotel.HotelDetails[0].Pansion.Value;
    const durationInNight = hotel.DurationInNight;
    const variant = `${hotel.Hotel.Value} / ${hotel.City.Value} / ${hotel.Stars.Value || ""} / ${correctDurationNight(durationInNight)}`;
    const roomtype = `${accomodationType} / ${roomCategory} / ${room} / ${pansion}`;

    let dataLayer = window.dataLayer || [];
    dataLayer.push({ "ecommerce": null });
    dataLayer.push({
        "event": "productClick",
        "ecommerce": {
            "currencyCode": store.getters['getNationalRate'].IsoCode, //window.settings.GTM_CurrencyIsoCode,
            "click": {
                "actionField": {
                    "list": "Выбор размещения"
                },
                "products": [{
                    "id": data.Key,
                    "name": data.Name,
                    "price": convertCurrency(currency, data.Cost),
                    "brand": brand,
                    "category": "Tour",
                    "variant": variant,
                    "roomtype": roomtype,
                    "position": key,
                }]
            }
        }
    });
};

export const toBasket = (data, key, touristCount, currency, food = null) => {
    let brand = data.allData.Services.find(x2 => x2.SvKey === 1)?.ArrivalCountry?.Value || "";
    if (!brand) {
        brand = data.allData.Services.find(x2 => x2.SvKey === 3)?.Country?.Value || "";
    }
    if (!brand) {
        brand = data.allData.Services.find(x2 => x2.SvKey === 14)?.CountryTo?.Value || "";
    }
    const hotel = data?.allData?.Services.find(x2 => x2.SvKey === 3);
    let index = 0;
    if (food != null)
        index = hotel ? hotel.HotelDetails.map(x => `${x.HotelRoom}_${x.Pansion.Key}_${x.PartnerId}`).indexOf(food[2]) : 0;
    if (index === -1) index = 0;

    const roomCategory = hotel ? hotel.HotelDetails[index].RoomCategory.Value : "";
    const room = hotel ? hotel.HotelDetails[index].Room.Value : "";
    const accomodationType = hotel ? hotel.HotelDetails[index].AccomodationType.Value : "";
    const pansion = hotel ? hotel.HotelDetails[index].Pansion.Value : "";
    const durationInNight = hotel ? hotel.DurationInNight : "";
    let variant = `${hotel?.Hotel?.Value || ""} / ${hotel?.City?.Value || ""} / ${hotel?.Stars?.Value || ""} / ${hotel ? correctDurationNight(durationInNight) : ""}`;
    let roomtype = `${accomodationType} / ${roomCategory} / ${room} / ${pansion}`;
    if (!hotel) {
        variant = "";
        roomtype = "";
    }

    const products = [{
        "id": data.allData.Key,
        "name": data.allData.Name,
        "price": convertCurrency(currency, data.cost),
        "brand": brand,
        "category": "Tour",
        "variant": variant,
        "roomtype": roomtype,
        "position": key,
        "quantity": 1
    }];
    firstProducts = JSON.parse(JSON.stringify(products[0]));
    firstProducts.position = 0;

    let dataLayer = window.dataLayer || [];
    dataLayer.push({ "ecommerce": null });
    dataLayer.push({
        "event": "addToCart",
        "ecommerce": {
            "currencyCode": store.getters['getNationalRate'].IsoCode, //window.settings.GTM_CurrencyIsoCode,
            "add": {
                "products": products
            }
        }
    });
};

export const addToCart = (data, cost, type, tour, currency, name, event) => {
    const products = correctingProduct(data, cost, type, name, currency, true);
    if (data.IsNotCalculate) {
        event = "addToCart"
    }

    let dataLayer = window.dataLayer || [];
    dataLayer.push({ "ecommerce": null });
    dataLayer.push({
        "event": event,
        "ecommerce": {
            "currencyCode": store.getters['getNationalRate'].IsoCode, //window.settings.GTM_CurrencyIsoCode,
            "add": {
                "products": products
            }
        }
    });
};

export const updateCard = (data, cost, type, tour, currency, name, event, oldName, oldCost) => {
    removeFromCard(data, oldCost, type, tour, currency, oldName, event);
    addToCart(data, cost, type, tour, currency, name, event);
};

export const removeFromCard = (data, cost, type, tour, currency, name, event) => {
    const products = correctingProduct(data, cost, type, name, currency);
    if (data.IsNotCalculate) {
        event = "changeCart"
    }

    let dataLayer = window.dataLayer || [];
    dataLayer.push({ "ecommerce": null });
    dataLayer.push({
        "event": event,
        "ecommerce": {
            "currencyCode": store.getters['getNationalRate'].IsoCode, //window.settings.GTM_CurrencyIsoCode,
            "remove": {
                "products": products
            }
        }
    });
};

export const checkout = (products, actionField, defaultServicesCost, currency) => {
    firstProducts.price = convertCurrency(currency, defaultServicesCost);
    products = correctingProducts(products, currency);
    let i = 1;
    products = JSON.parse(JSON.stringify(products)).map(x => {
        x.position = i;
        i++;
        return x
    });

    let correctFirstProduct = JSON.parse(JSON.stringify(firstProducts));
    delete correctFirstProduct.roomtypeOld;

    let dataLayer = window.dataLayer || [];
    dataLayer.push({ "ecommerce": null });
    dataLayer.push({
        "event": "checkout",
        "ecommerce": {
            "currencyCode": store.getters['getNationalRate'].IsoCode, //window.settings.GTM_CurrencyIsoCode,
            "checkout": {
                "actionField": actionField,
                "products": [
                    correctFirstProduct,
                    ...products
                ]
            }
        }
    });
};

export const transaction = (products, actionField, currency) => {
    actionField.revenue = convertCurrency(currency, actionField.revenue);
    actionField.tax = convertCurrency(currency, actionField.tax);

    products = correctingProducts(products, currency);
    let i = 1;
    products = JSON.parse(JSON.stringify(products)).map(x => {
        x.position = i;
        i++;
        return x
    });

    let correctFirstProduct = JSON.parse(JSON.stringify(firstProducts));
    delete correctFirstProduct.roomtypeOld;

    let dataLayer = window.dataLayer || [];
    dataLayer.push({ "ecommerce": null });
    dataLayer.push({
        "event": "transaction",
        "ecommerce": {
            "currencyCode": store.getters['getNationalRate'].IsoCode, //window.settings.GTM_CurrencyIsoCode,
            "purchase": {
                "actionField": actionField,
                "products": [
                    correctFirstProduct,
                    ...products
                ]
            }
        }
    });
};


/* Local methods */
function correctDurationNight(n) {
    if (n <= 1)
        return n +" ночь";
    else if (n < 5)
        return  n +" ночи";
    else
        return  n +" ночей";
}

function convertCurrency(code, cost) {
    const currencyRates = store.getters['getCurrencyRates'];
    const currencies = store.getters['getAllCurrency'];

    const currency = currencies.find(x => x.IsoCode === code);
    const rate = currencyRates.find(x => x.CurrencyId === currency.Key)?.Rate || 1;

    return (rate * cost).toFixed(2)
}

function correctingProduct(data, cost, type, name, currency, isAdded = false) {
    let product = [{
        "id": firstProducts.id,
        "name": firstProducts.name,
        "price": cost,
        "brand": firstProducts.brand,
        "category": data.IsNotCalculate ? type : "Tour",
        "variant": firstProducts.variant,
        "roomtype": firstProducts.roomtype,
        "position": 0,
        "quantity": 1
    }];
    product = correctingProducts(product, currency, true);

    if (data.IsNotCalculate) {
        product[0].id = data.Id;
        product[0].name = name;
        delete product[0].brand;
        delete product[0].variant;
        delete product[0].roomtype;
    }
    if (individualServiceCategories.includes(type) && data.IsNotCalculate) {
        product[0].quantity = 1
    }
    if (type === "Hotel" && !isAdded) {
        product[0].roomtype = firstProducts.roomtypeOld
    }
    return product
}
function correctingProducts(product, currency, forOne = false) {
    const arr = JSON.parse(JSON.stringify(product));
    let res = [];

    for (let i = 0; i < arr.length; i++) {
        const isIndividualService = individualServiceCategories.includes(arr[i].category);

        arr[i].price = convertCurrency(currency, arr[i].price);

        if (isIndividualService && !forOne) {
            const quantity = arr[i].quantity;

            arr[i].quantity = 1;
            arr[i].price = parseFloat(arr[i].price) / quantity;
            arr[i].price += "";
            for (let i2 = 0; i2 < quantity; i2++) {
                res.push(arr[i])
            }
        } else {
            res.push(arr[i])
        }
    }

    return res;
}